import { SKILLS, type SkillKey } from "@mathtrain/engine";
import { Link } from "react-router-dom";
import { timeAgo } from "../lib/hooks";
import type { FeedEvent } from "../lib/types";
import { Avatar } from "./Avatar";

/** One line per event kind. Add a kind on the server (addEvent) and describe it here. */
function describe(e: FeedEvent): string {
  switch (e.kind) {
    case "joined": return "joined";
    case "daily": return `scored ${e.data.score} on the daily challenge${e.data.rank ? `, #${e.data.rank} so far` : ""} (${e.data.correct}/10)`;
    case "levelup": return `reached level ${e.data.level} in ${SKILLS[e.data.skill as SkillKey]?.name ?? e.data.skill}`;
    case "goal": return `reached a goal: ${e.data.title}`;
    case "trial": return `passed the level ${e.data.level} trial in ${SKILLS[e.data.skill as SkillKey]?.name ?? e.data.skill}`;
    case "streak": return `hit a ${e.data.days}-day streak`;
    case "challenge": return `challenged ${e.data.to} to a duel`;
    case "challenge_result": return e.data.tie ? "tied a duel" : `beat ${e.data.beat} in a duel, ${e.data.score} to ${e.data.theirs}`;
    default: return e.kind;
  }
}

export function Feed({ events }: { events: FeedEvent[] }) {
  if (!events.length) return <div className="empty">Nothing yet. Finish a session to get things started.</div>;
  return <ul className="feed">
    {events.map((e) => <li key={e.id}>
      <Avatar user={e.user} />
      <div><Link to={`/u/${e.user.username}`}><b>{e.user.displayName}</b></Link> {describe(e)}<time>{timeAgo(e.at)}</time></div>
    </li>)}
  </ul>;
}
